import React, { PureComponent } from "react";
import OneColumnLayout from "../../layouts/one-column";

class TeamReportsSection2Step1 extends PureComponent {
  get content() {
    const { current_year } = this.props;

    if (current_year <= 4) {
      return (
        <span>
          1. Market Share
          <br />
          2. Revenues
          <br />
          3. Gross Margins
          <br />
          4. Share Price
        </span>
      );
    }

    return (
      <span>
        1. Share Price
        <br />
        2. Earnings Per Share
        <br />
        3. Return on Invested Capital (ROIC)
        <br />
        4. Return on Net Operating Assets (RNOA)
      </span>
    );
  }

  render() {
    return (
      <OneColumnLayout
        title="KPI Analysis - Metrics That Drive Grade & Ranking"
        content={this.content}
      />
    );
  }
}

export default TeamReportsSection2Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-2.js